import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2282e5e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4" }
const _hoisted_2 = { class: "tw-w-[100px] tw-h-[100px] tw-overflow-hidden" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "tw-w-full tw-grid tw-grid-cols-1 tw-items-center tw-gap-3" }

import { computed, ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import { PROJECT_STORE } from "@/store/modules/project";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoricalProjectSavingStepsModal',
  props: ["loading"],
  emits: ["on-close", "on-success", "on-confirm"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;

const store = useStore();
const route = useRoute();

const state = reactive({
  loading: false,
});

const switchingImage = ref("home-verify.png");
const switchingText = ref("");
const tabListItemsTradeVerified = [
  {
    tab: "step1",
    name: "Sending Contractors your invitation...",
  },
  {
    tab: "step2",
    name: "Saving your Historical Project...",
  },
  {
    tab: "step3",
    name: "Your Historical Project has successfully been saved!",
  },
];
const tabListItemsDiy = [
  {
    tab: "step1",
    name: "Saving your Historical Project...",
  },
  {
    tab: "step2",
    name: "Your Historical Project has successfully been saved!",
  },
];
const currentSelectedTabTradeVerified = ref(tabListItemsTradeVerified[0]);
const currentSelectedTabDIY = ref(tabListItemsDiy[0]);

const projectDetailsForm = computed(
  () => store.getters[`${PROJECT_STORE}/projectDetails`]
);

const isDiy = computed(
  () => projectDetailsForm.value.projectType === "DIY Project"
);

const onCloseModal = () => {
  emits("on-close");
};

const onSuccess = () => {
  emits("on-success");
};

const delay = (ms: any) => new Promise((resolve) => setTimeout(resolve, ms));

onMounted(async () => {
  if (!isDiy.value) {
    switchingText.value = "Sending Contractors your invitation...";
    switchingImage.value = "user-blue-cap.png";
    currentSelectedTabTradeVerified.value = tabListItemsTradeVerified[0];

    // Second step: Wait for 2 seconds
    await delay(2000);
    switchingText.value = "Saving your Historical Project...";
    switchingImage.value = "home-verify.png";
    currentSelectedTabTradeVerified.value = tabListItemsTradeVerified[1];

    // Third step: Wait for 5 seconds
    await delay(5000);
    switchingText.value =
      "Your Historical Project has successfully been saved!";
    switchingImage.value = "check-blue.svg";
    currentSelectedTabTradeVerified.value = tabListItemsTradeVerified[2];
  }

  if (isDiy.value) {
    switchingText.value = "Saving your Historical Project...";
    switchingImage.value = "home-verify.png";
    currentSelectedTabDIY.value = tabListItemsDiy[0];

    // second step: Wait for 5 seconds
    await delay(5000);
    switchingText.value =
      "Your Historical Project has successfully been saved!";
    switchingImage.value = "check-blue.svg";
    currentSelectedTabDIY.value = tabListItemsDiy[1];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    isShowCloseButton: false,
    class: "tw-w-[450px] tw-h-[430px] tw-max-w-full"
  }, {
    body: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createVNode(Text, {
          variat: "h5",
          textColor: "#264FD5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(switchingText.value), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "tw-w-full tw-h-full",
            cover: "",
            src: require('@/assets/icons/' + switchingImage.value)
          }, null, 8, _hoisted_3)
        ]),
        (isDiy.value)
          ? (_openBlock(), _createBlock(_component_v_stepper, {
              key: 0,
              class: "onboard-stepper",
              modelValue: currentSelectedTabDIY.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSelectedTabDIY.value.name) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabListItemsDiy, (step, index) => {
                      return _createVNode(_component_v_stepper_item, {
                        class: "onboard-stepper__item",
                        key: index,
                        value: step.name
                      }, null, 8, ["value"])
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (!isDiy.value)
          ? (_openBlock(), _createBlock(_component_v_stepper, {
              key: 1,
              class: "onboard-stepper",
              modelValue: currentSelectedTabTradeVerified.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentSelectedTabTradeVerified.value.name) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabListItemsTradeVerified, (step, index) => {
                      return _createVNode(_component_v_stepper_item, {
                        class: "onboard-stepper__item",
                        key: index,
                        value: step.name
                      }, null, 8, ["value"])
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (
            currentSelectedTabTradeVerified.value.tab === 'step3' ||
            currentSelectedTabDIY.value.tab === 'step2'
          )
          ? (_openBlock(), _createBlock(Button, {
              key: 0,
              disabled: __props.loading,
              isLoading: __props.loading,
              label: "Back to Project Logs",
              isActive: true,
              onClick: onSuccess
            }, null, 8, ["disabled", "isLoading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})